import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, filter, map, Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  ActivityLogModel,
  ActivityLogResponseModel,
} from '../models/activity-log/activity-log.model';
import { StudyFileMediaInfoDto } from '../models/Study/study-file.model';

export class Log {
  userId: number;
  documentId: number;
}
@Injectable({
  providedIn: 'root',
})
export class ActivityLogService {
  public baseUrl = environment.api2BaseUrl;
  public onError: BehaviorSubject<string> = new BehaviorSubject('');
  public serviceParameter = {
    'Content-Type': 'application/json; charset=utf-8',
    Accept: 'application/json',
    Authorization: '',
  };
  public constructor(
    private readonly http: HttpClient,
    private router: Router
  ) {

  }

  getStudyFileMediaConversionActivity(studyFileId: number): Observable<StudyFileMediaInfoDto> {
    return this.http
      .get<StudyFileMediaInfoDto>(`${this.baseUrl}/api/studyFiles/${studyFileId}/mediaConversionInfo`, {
        withCredentials: false,
        observe: 'response',
      })
      .pipe(map((res) => res.body));
  }

  public addActivityLog(log: ActivityLogModel): Observable<number> {
    return this.http
      .post<number>(`${this.baseUrl}/api/Activity`, log, {
        withCredentials: false,
        observe: 'response',
      })
      .pipe(map((res) => res.body));

  }

  public updateActivityLog(log: number): Observable<ActivityLogResponseModel> {
    return this.http
      .patch<ActivityLogResponseModel>(
        `${this.baseUrl}/api/Activity/${log}`,
        null,
        {
          withCredentials: false,
          observe: 'response',
        }
      )
      .pipe(map((res) => res.body));

  }

  public logDocumentOpen(userId: number, documentId: number): void {
    const logs: Log[] = JSON.parse(localStorage.getItem('reportLog'));
    if (
      !logs.find(
        (log) => log.userId === userId && log.documentId === documentId
      )
    ) {
      logs.push({ userId, documentId });
      localStorage.setItem('reportLog', JSON.stringify(logs));
      // console.log('Logged report opening');
    }
  }

  public checkIfReportOpened(userId: number, documentId: number): boolean {
    const logs: Log[] = JSON.parse(localStorage.getItem('reportLog'));
    const log = logs.find(
      (log) => log.userId === userId && log.documentId === documentId
    );
    return !!log;
  }
}
